/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const analyticsPipelineCountsDataSchema = z.object({
	new: z.number(),
	other: z.number(),
	hired: z.number(),
	rejected: z.number(),
})

export type AnalyticsPipelineCountsDataSchema = z.infer<typeof analyticsPipelineCountsDataSchema>
